/* eslint class-methods-use-this: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DatePicker, FlexibleDatePicker } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/DatePicker/DatePicker.css';
import '@spotahome/ui-library/lib/components/DatePicker/lib/pikaday.css';
import '@spotahome/ui-library/lib/components/FlexibleDatePicker/FlexibleDatePicker.css';
import '@spotahome/ui-library/lib/components/FlexibleDatePicker/components/FlexibleDatesCheckbox.css';
import '@spotahome/ui-library/lib/components/Checkbox.css';

import { trans } from '@spotahome/bff/client';

import GlobalSettings from '../../LEGACY/javascripts/cornucopia/core/global-settings';

import './DatesInput.scss';

const TRANS_DELIMITER = '_';

const defaultStyles = {
  arrow: 'dates-input--dates-arrow',
  calendar: 'dates-input--calendar',
  container: 'dates-input--container-dates',
  from: 'dates-input--date-input',
  inputWrapper: 'dates-input--input-wrapper',
  to: 'dates-input--date-input'
};

class DatesInput extends Component {
  componentDidCatch(error, info) {
    if (window.newrelic) {
      window.newrelic.noticeError(error, { info });
    }
  }

  getI18N() {
    const { texts } = this.props;
    return {
      previousMonth: trans('pikaday.label.previous_month'),
      nextMonth: trans('pikaday.label.next_month'),
      months: trans('pikaday.label.months').split(TRANS_DELIMITER),
      weekdays: trans('pikaday.label.weekdays').split(TRANS_DELIMITER),
      weekdaysShort: trans('pikaday.label.weekdays_short').split(
        TRANS_DELIMITER
      ),
      dateInPlaceholder: texts.moveInPlaceholder,
      dateOutPlaceholder: texts.moveOutPlaceholder
    };
  }

  getStyling() {
    const { styling } = this.props;

    return {
      arrow: classNames(defaultStyles.arrow, styling.arrow),
      calendar: classNames(defaultStyles.calendar, styling.calendar),
      container: classNames(defaultStyles.container, styling.container),
      from: classNames(defaultStyles.from, styling.from),
      inputWrapper: classNames(
        defaultStyles.inputWrapper,
        styling.inputWrapper
      ),
      to: classNames(defaultStyles.to, styling.to)
    };
  }

  render() {
    const {
      autoCompleteDates,
      dateFormat,
      disableMoveIn,
      disableMoveOut,
      flexibleDates,
      maxStay,
      minStay,
      minDate,
      moveIn,
      moveInterval,
      moveOut,
      onChange,
      show
    } = this.props;

    const i18n = this.getI18N();
    const styling = this.getStyling();

    const settings = {
      dateFormat,
      minDate,
      minStay,
      maxStay,
      moveInterval
    };

    const props = {
      autoCompleteDates,
      disableDayFnMoveIn: disableMoveIn,
      disableDayFnMoveOut: disableMoveOut,
      fromDate: moveIn,
      i18n,
      onChange,
      settings,
      showFromDate: show && !moveIn,
      showToDate: show && !moveOut,
      styles: styling,
      toDate: moveOut
    };

    if (flexibleDates) {
      return <FlexibleDatePicker {...props} {...flexibleDates} />;
    }

    return <DatePicker {...props} />;
  }
}

const flexibleDatesShape = {
  flexibleMoveIn: PropTypes.bool,
  flexibleMoveOut: PropTypes.bool,
  onFlexibleMoveInChange: PropTypes.func,
  onFlexibleMoveOutChange: PropTypes.func
};

const stylingShape = {
  moveIn: PropTypes.string,
  moveInCalendar: PropTypes.string,
  moveOut: PropTypes.string,
  moveOutCalendar: PropTypes.string,
  wrapper: PropTypes.string
};

const textsShape = {
  moveInPlaceholder: PropTypes.string,
  moveOutPlaceholder: PropTypes.string
};

DatesInput.propTypes = {
  autoCompleteDates: PropTypes.bool,
  dateFormat: PropTypes.string,
  disableMoveIn: PropTypes.func,
  disableMoveOut: PropTypes.func,
  flexibleDates: PropTypes.shape(flexibleDatesShape),
  maxStay: PropTypes.number,
  minStay: PropTypes.number,
  moveIn: PropTypes.string,
  moveInterval: PropTypes.number,
  moveOut: PropTypes.string,
  onChange: PropTypes.func,
  show: PropTypes.bool,
  styling: PropTypes.shape(stylingShape),
  texts: PropTypes.shape(textsShape)
};

DatesInput.defaultProps = {
  autoCompleteDates: true,
  dateFormat: 'YYYY-MM-DD',
  disableMoveIn: undefined,
  disableMoveOut: undefined,
  flexibleDates: null,
  maxStay: 0,
  minStay: GlobalSettings.getMinStay(),
  moveIn: '',
  moveInterval: GlobalSettings.getMoveDatesInterval(),
  moveOut: '',
  onChange: () => {},
  show: false,
  styling: {
    calendar: '',
    moveIn: '',
    moveOut: '',
    wrapper: ''
  },
  texts: {
    moveInPlaceholder: '',
    moveOutPlaceholder: ''
  }
};

export default DatesInput;
